/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Filter_PlaceholderInputs */

const en_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const de_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const fr_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const es_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const it_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const nl_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const pl_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const fi_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const da_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

const sv_story_bank_filter_placeholder = /** @type {(inputs: Story_Bank_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by title, tag, or skill...`)
};

/**
* | output |
* | --- |
* | "Filter by title, tag, or skill..." |
*
* @param {Story_Bank_Filter_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_filter_placeholder = /** @type {((inputs?: Story_Bank_Filter_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Filter_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_filter_placeholder(inputs)
	if (locale === "fr") return fr_story_bank_filter_placeholder(inputs)
	if (locale === "es") return es_story_bank_filter_placeholder(inputs)
	if (locale === "it") return it_story_bank_filter_placeholder(inputs)
	if (locale === "nl") return nl_story_bank_filter_placeholder(inputs)
	if (locale === "pl") return pl_story_bank_filter_placeholder(inputs)
	if (locale === "fi") return fi_story_bank_filter_placeholder(inputs)
	if (locale === "da") return da_story_bank_filter_placeholder(inputs)
	if (locale === "sv") return sv_story_bank_filter_placeholder(inputs)
	return en_story_bank_filter_placeholder(inputs)
});